<template>
    <div class="provider-features">
        <div v-if="provider.telehealth_physician" class="item">
            <i aria-hidden="true" class="far fa-file-video"></i>
            <span>Provides Virtual Visits</span>
        </div>
        <div v-if="provider.languages" class="item">
            <i aria-hidden="true" class="far fa-comments"></i>
            <span>Additional Languages: {{ provider.languages }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        provider: {type: Object, required: true},
    },
};
</script>
